import React from 'react';
import Chip from '@material-ui/core/Chip';

const HotelRequestChips = ({ customClasses, variant, hotelResources }) => {
    return (
        <>
            {
                hotelResources.map((resource, index) =>
                    <Chip
                        key={index}
                        size="small"
                        label={resource.destinationName}
                        className={customClasses}
                        color="primary"
                        variant={variant}
                    />
                )
            }
        </>
    )
}

export default HotelRequestChips;